import { render } from "./LockIcon.vue?vue&type=template&id=395b1058"
import script from "./LockIcon.vue?vue&type=script&lang=js"
export * from "./LockIcon.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__